import { createDataAttribute } from 'next-sanity';

import type { SanitySource } from '#/lib/types';

import { getSanityStudioUrl } from './studioUrl';

const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID;
const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET;

type SanityDataAttributeOptions = {
  documentId: string;
  documentType: string;
  path: string;
};

export function createSanityDataAttribute({
  documentId,
  documentType,
  path,
}: SanityDataAttributeOptions) {
  if (!projectId || !dataset) return undefined;

  return createDataAttribute({
    projectId,
    dataset,
    baseUrl: getSanityStudioUrl(dataset),
    id: documentId,
    type: documentType,
    path,
  }).toString();
}

export function createSanityFieldDataAttribute(
  source: SanitySource | undefined,
  fieldPath?: string,
) {
  if (!source) return undefined;

  return createSanityDataAttribute({
    ...source,
    path: fieldPath ? `${source.path}.${fieldPath}` : source.path,
  });
}
